// extracted by mini-css-extract-plugin
module.exports = {"favorite":"Favorite_favorite__3Ebh7","favoriteFilled":"Favorite_favoriteFilled__16LBw"};